import React from 'react';
import styled from 'styled-components';

import { ShimmerOverlay } from 'components/Globals';

const Flex = styled.div`
  display: flex;
  position: relative;
`;

const SkeletonLine = styled.div`
  display: flex;
  position: relative;
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  margin-top: ${({ mt }) => (mt ? `${mt}px` : 0)};
  margin-left: ${({ ml }) => (ml ? `${ml}px` : 0)};
  opacity: ${({ opacity }) => opacity || 1};
  background-color: ${({ theme, transparent }) => (transparent ? 'transparent' : theme.color.grey[4])};
  border-radius: 4px;
`;

const SkeletonCircle = styled.div`
  display: flex;
  position: relative;
  height: ${({ radius }) => (radius ? `${radius * 2}px` : '48px')};
  width: ${({ radius }) => (radius ? `${radius * 2}px` : '48px')};
  border-radius: 50%;
  margin-top: ${({ mt }) => (mt ? `${mt}px` : 0)};
  margin-left: ${({ ml }) => (ml ? `${ml}px` : 0)};
  opacity: ${({ opacity }) => opacity || 1};
  background-color: ${({ theme, transparent }) => (transparent ? 'transparent' : theme.color.grey[4])};
`;

const SkeletonBox = ({ children, offwhite, ...rest }) => (
  <Flex {...rest}>
    <ShimmerOverlay offwhite={offwhite}>{children}</ShimmerOverlay>
  </Flex>
);

export { SkeletonLine, SkeletonBox, SkeletonCircle, Flex };
